const LoadingSkeleton = ({height, width}) => {
    return (
        <div className="loading-skeleton" style={{height, width}}></div>
    )
}

export default LoadingSkeleton